import {Injectable} from '@angular/core';
import {SystemApiClient} from "../clients/system-api/SystemApiClientp";
import {Observable} from "rxjs";
import {
  PaginationArgs,
  ServiceTypeDataPaginationDataAdministrationResult
} from "../clients/system-api/SystemApiClient";

@Injectable({
  providedIn: 'root'
})
export class ServiceTypeService {

  constructor(private apiClient: SystemApiClient) {
  }

  retrieveAllServiceTypes(args: PaginationArgs): Observable<ServiceTypeDataPaginationDataAdministrationResult> {
    return this.apiClient.retrieveAllServiceTypes(args);
  }
}
